import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import InfoBox from 'components/Shared/InfoBox'
import Input from 'components/Shared/Input'
import {
  useCampaignSetup,
  useCampaignSetupDispatch,
} from 'components/Recommendations/Campaign/Context/CampaignSetupContext'

export default function Payer({ recommendation, disabled = false }) {
  const { t } = useTranslation()
  const { setup } = useCampaignSetup()
  const { updateDsaFields } = useCampaignSetupDispatch()

  const payer = setup?.dsa_payor ?? recommendation

  return (
    <div className="field-wrapper">
      <InfoBox content="Tips.Recommendations.payer">
        <span>{t('Recommendations.summary.advancedSettings.payer.title')}</span>
      </InfoBox>

      <Input
        value={payer}
        onChange={(e) => {
          const value = e.target.value
          updateDsaFields({ dsa_payor: value })
        }}
        wrapperClass="mb-0 w-100"
        disabled={disabled}
      />
    </div>
  )
}

Payer.propTypes = {
  recommendation: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}